namespace TabAurous.Retail {
    export interface ReceiptDetailsForm {
        Mode: Serenity.LookupEditor;
        LedgerId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        RefNo: Serenity.StringEditor;
        BankId: Serenity.LookupEditor;
        ChequeNo: Serenity.IntegerEditor;
        ChequeDate: Serenity.DateEditor;
        Denominations: ReceiptDenominationDetailsEditor;
    }

    export class ReceiptDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.ReceiptDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptDetailsForm.init)  {
                ReceiptDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;
                var w5 = ReceiptDenominationDetailsEditor;

                Q.initFormType(ReceiptDetailsForm, [
                    'Mode', w0,
                    'LedgerId', w0,
                    'Amount', w1,
                    'RefNo', w2,
                    'BankId', w0,
                    'ChequeNo', w3,
                    'ChequeDate', w4,
                    'Denominations', w5
                ]);
            }
        }
    }
}
